const parts = ['wrapper', 'input', 'label', 'helperText', 'error',];

const baseStyle = {
    wrapper: {
        display: "flex",
        flexDir: "column-reverse",
        h: "3.75rem",
        mt: "2rem",
    },
    input: {
        bg: "#fafafa",
        border: "1px solid #e6e6e6",
        padding: ".9em 1.2em",
        _hover: {
            bg: "white",
        },
        _focus: {
            bgColor: "#f2fcfc",
            borderColor: "#00b0b1",
        }
    },
    label: {
        fontSize: "1.1em",
        fontWeight: "700",
        pb: "0.2rem",
        width: "max-content",
    },
    helperText: {},
    error: {},
}

export default {
    baseStyle,
    parts
}
